import type { GlobalErrorCode } from '../constants/global.constants';
import {
  PortalComponent,
  useComponentPortalContext,
} from '../contexts/ComponentPortalContext';

const useErrorToast = (): {
  showErrorToast: (
    errorCode: GlobalErrorCode,
    statusCode: number,
    message?: string,
  ) => void;
} => {
  const { setComponentVisibility } = useComponentPortalContext();

  const showErrorToast = (
    errorCode: GlobalErrorCode,
    statusCode: number,
    message?: string,
  ): void => {
    console.error(
      `${errorCode} (${statusCode})${message ? `: ${message}` : ''}`,
    );

    setComponentVisibility({
      component: PortalComponent.ERROR_TOAST,
      data: { statusCode },
      isVisible: true,
    });
  };

  return {
    showErrorToast,
  };
};

export default useErrorToast;
